import { GET_TEMPLATE, POST_BALANCE_SHEET, SET_CODES_OBJECT, GET_FINANCIAL_STATEMENTS, GET_FS_INPUTS, UPDATE_BALANCE_SHEET } from '../actions/transformation_input_two'
// import Vue from 'vue'
import { RepositoryFactory } from '../repositories/RepositoryFactory'
import { store } from '../store/store'
import { UPDATELOGGEDINUSER } from '../actions/user'
// console.log(RepositoryFactory);
const Repository = RepositoryFactory.get('transformation_input_one')
const state = {
  template: {},
  // financial_statment_key: '',
  codesObject: localStorage.getItem('codesObject') ? JSON.parse(localStorage.getItem('codesObject')) : {}
}

const mutations = {
  [GET_TEMPLATE]: (state, result) => {
    state.template = result.template
  },
  [POST_BALANCE_SHEET]: (state, result) => {
    // state.financial_statment_key = result
    // localStorage.removeItem('financialObjTemp')
  },
  [UPDATE_BALANCE_SHEET]: (state, result) => {
    // state.financial_statment_key = result
    // localStorage.removeItem('financialObjTemp')
  },
  [SET_CODES_OBJECT]: (state, data) => {
    state.codesObject = data
  }
}

const actions = {
  /**
     * Get template from server
     * module one input two
     */
  [GET_TEMPLATE]: ({commit}) => {
    Repository.getTemplate().then(async (result) => {
      console.log('result vuex', result)
      if (result.data.Error !== undefined) {
        console.log('if true still notification display?')
        // await store.dispatch('UPDATELOGGEDINUSER', result.data)
        // commit('NOTIFICATION', result.data.Error)
        commit('ERRORS', result.data.Error)
        // this.$store.dispatch('UPDATELOGGEDINUSER', result.data)
      } else {
        let template = result.data
        commit(GET_TEMPLATE, {'template': template})
      }
    }).catch((error) => {
      console.log('from catch block')
      commit('ERRORS', error)
    })
  },
  [POST_BALANCE_SHEET]: async ({commit}, postdata) => {
    try {
      const result = await Repository.postBalanceSheet(postdata)
      // console.log('blalalal', result.data.user)
      commit(POST_BALANCE_SHEET)
      commit(UPDATELOGGEDINUSER, {'data': result.data.user})
      return result
    } catch (error) {
      commit('ERRORS', error.response.data.error)
      // return error.data
    }
  },
  [UPDATE_BALANCE_SHEET]: async ({commit}, postdata) => {
    try {
      const result = await Repository.updateBalanceSheet(postdata[0], postdata[1])
      commit(UPDATE_BALANCE_SHEET)
      return result
    } catch (error) {
      commit('NOTIFICATION', error.data)
      return error.data
    }
  },
  [SET_CODES_OBJECT]: ({ commit }, data) => {
    commit(SET_CODES_OBJECT, data)
  },
  [GET_FINANCIAL_STATEMENTS]: async ({commit}, data) => {
    let response = await Repository.userFinancialStatements(data)
    console.log('response', response.data)
    commit(UPDATELOGGEDINUSER, {'data': response.data.user})
    return response
  },
  [GET_FS_INPUTS]: async ({commit}, data) => {
    let res = await Repository.editFinancialStatement(data)
    return res.data
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/modules/transformation_input_two.js